import React from "react"
import { useRecoilValue } from "recoil";
import { settingsState } from "../../state";


const HighlightHeading = ({ heading, highlight, mainColor }) => {
    if (!heading || !highlight) return <span>{heading}</span>;

    const parts = heading.split(new RegExp(`(${highlight})`, "gi"));

    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === highlight.toLowerCase() ? (
                    <span key={index} style={{ color: mainColor }}>
                        {part}
                    </span>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </span>
    );

}



export const Heading = ({ data, size = "large", settings })=> {
    const { mainColor } = useRecoilValue(settingsState);
    if(!data) return <></>

    const { heading, subheading, highlight } = data

    return <div>
        {subheading && <h6 className="subheading" style={{color: mainColor}}>{subheading}</h6>}
        {size === "large" && <h1><HighlightHeading heading={heading} highlight={highlight} mainColor={mainColor} /></h1>}
        {size === "medium" && <h2><HighlightHeading heading={heading} highlight={highlight} mainColor={mainColor} /></h2>}
        {size === "small" && <h4><HighlightHeading heading={heading} highlight={highlight} mainColor={mainColor} /></h4>}
    </div >
}



